export default __webpack_public_path__ + "static/contact-tab-four-96cd7b363dbd035f6e169626548a5b48.jpg";